import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import AsyncSelect from 'react-select/async';

type Props = {
  fieldName: string,
  defaultUserUid?: string|null,
};

type FetchedUser = {
  uid: string,
  email: string,
  fullname: string,
  created_at: string,
}
type UserOption = {
  value: string,
  label: string,
};


const fetchUsers = (inputValue: string): Promise<UserOption[]> => {
  return new Promise((resolve, reject) => {
    axios.get('/admin/users/search', {
      params: {
        q: {
          email_or_fullname_cont: inputValue,
        },
      },
    })
    .then(response => {
      const users: FetchedUser[] = response.data;
      const options: UserOption[] = users.map(user => ({
        value: user.uid,
        label: `${user.fullname} (${user.email})`,
      }));
      resolve(options);
    })
    .catch(error => {
      console.error("Error fetching users:", error);
      reject([]);
    });
  });
}

const fetchUser = (uid: string): Promise<UserOption|null> => {
  return new Promise((resolve, reject) => {
    axios.get(`/admin/users/${uid}/retrieve`)
    .then(response => {
      const user: FetchedUser = response.data;
      const option: UserOption = {
        value: user.uid,
        label: `${user.fullname} (${user.email})`,
      };
      console.log(option);
      resolve(option);
    })
    .catch(error => {
      console.error("Error fetching user:", error);
      resolve(null);
    });
  });
}

const styles = {
  control: styles => ({ ...styles,
    backgroundColor: 'white',
    minWidth: '200px',
    minHeight: '31px',
    height: '31px',
    boxShadow: 'none'
  }),
  input: styles => ({ ...styles, height: '20px', padding: '0' }),
  valueContainer: styles => ({ ...styles, height: '29px' }),
  indicatorsContainer: styles => ({ ...styles, height: '29px' }),
};

const UserSearchField: React.FC<Props> = ({
  fieldName,
  defaultUserUid,
}) => {
  const [user, setUser] = useState<UserOption|null>(null);

  useEffect(() => {
    if (!defaultUserUid) { return; }
    (async () => {
      const fetchedUser = await fetchUser(defaultUserUid);
      if (fetchedUser) {
        setUser(fetchedUser);
      }
    })();
  }, [defaultUserUid]);

  return(
    <>
      <AsyncSelect cacheOptions
        // defaultValue={defaultInstrument}
        loadOptions={fetchUsers}
        onChange={(newOption: UserOption) => {
          setUser(newOption);
        }}
        styles={styles}
        placeholder="ユーザーを検索"
        isClearable={true}
        value={user}
      />
      {user && (
        <input type="hidden" name={fieldName} value={user.value} />
      )}
    </>
  );
}

export default UserSearchField;